module.exports = __webpack_public_path__ + "media/images/games/world_culture_awareness/Cultural_Acceptance-1b2aee224bd9db54c16577a908dad9b7.jpg";